(function () {
"use strict";
var PROFILES = {
oversized_sneakers:{
type:"footwear",
label:"Oversized Sneakers",
measurementMode:"foot_length",
toeRoom:{
snug:0.50,
comfortable:0.65,
roomy:0.80
},
sockAllowance:0.10,
sizes:[
{men:"4",women:"5.5",eur:"36",insoleCm:24.0},
{men:"4.5",women:"6",eur:"37",insoleCm:24.6},
{men:"5.5",women:"7",eur:"38",insoleCm:25.3},
{men:"6.5",women:"8",eur:"39",insoleCm:26.0},
{men:"7.5",women:"9",eur:"40",insoleCm:26.7},
{men:"8.5",women:"10",eur:"41",insoleCm:27.3},
{men:"9.5",women:"11",eur:"42",insoleCm:28.0},
{men:"10",women:"11.5",eur:"43",insoleCm:28.7},
{men:"10.5",women:"12",eur:"44",insoleCm:29.3},
{men:"11",women:"12.5",eur:"45",insoleCm:30.0}
]
},
vegan_leather_boots:{
type:"footwear",
label:"Vegan Leather Boots",
measurementMode:"insole_reference",
variantSystem:"vegan_boots_flexible",
sizes:[
{men:"6.5",women:"8",eur:"39",uk:"6",insoleCm:25.20},
{men:"7",women:"8.5",eur:"40",uk:"6",insoleCm:26.11},
{men:"7.5",women:"9",eur:"40.5",uk:"6.5",insoleCm:26.49},
{men:"8",women:"9.5",eur:"41",uk:"7",insoleCm:27.00},
{men:"8.5",women:"10",eur:"42",uk:"7.5",insoleCm:27.41},
{men:"9",women:"10.5",eur:"42.5",uk:"8",insoleCm:27.89},
{men:"9.5",women:"11",eur:"43",uk:"8.5",insoleCm:28.19},
{men:"10",women:"11.5",eur:"44",uk:"9",insoleCm:28.70},
{men:"10.5",women:"12",eur:"44.5",uk:"9.5",insoleCm:29.21},
{men:"11",women:"12.5",eur:"45",uk:"10",insoleCm:29.49},
{men:"11.5",women:"13",eur:"45.5",uk:"10.5",insoleCm:29.90},
{men:"12",women:"13.5",eur:"46",uk:"11",insoleCm:30.40},
{men:"12.5",women:"14",eur:"47",uk:"11.5",insoleCm:30.81}
]
},
tr_sneakers_printy6:{
type:"footwear",
label:"TR Sneakers",
measurementMode:"foot_length",
toeRoom:{
snug:0.60,
comfortable:0.70,
roomy:0.80
},
sockAllowance:0.10,
sizes:[
{men:"3",women:"4.5",eur:"35",uk:"2.5",insoleCm:22.4},
{men:"4",women:"5.5",eur:"36",uk:"3.5",insoleCm:23.1},
{men:"5",women:"6.5",eur:"37",uk:"4.5",insoleCm:23.8},
{men:"5.5",women:"7",eur:"38",uk:"5",insoleCm:24.5},
{men:"6.5",women:"8",eur:"39",uk:"6",insoleCm:25.2},
{men:"7",women:"8.5",eur:"40",uk:"6",insoleCm:25.9},
{men:"8",women:"9.5",eur:"41",uk:"7",insoleCm:26.5},
{men:"8.5",women:"10",eur:"42",uk:"7.5",insoleCm:27.0},
{men:"9.5",women:"11",eur:"43",uk:"8.5",insoleCm:27.8},
{men:"10",women:"11.5",eur:"44",uk:"9",insoleCm:28.3},
{men:"11",women:"12.5",eur:"45",uk:"10",insoleCm:29.0},
{men:"12",women:"13.5",eur:"46",uk:"11",insoleCm:29.6},
{men:"12.5",women:"14",eur:"47",uk:"11.5",insoleCm:30.3},
{men:"13.5",women:"15",eur:"48",uk:"12.5",insoleCm:30.8}
]
},
tr_sneakers_subliminator:{
type:"footwear",
label:"TR Sneakers",
measurementMode:"foot_length",
toeRoom:{
snug:0.60,
comfortable:0.70,
roomy:0.80
},
sockAllowance:0.10,
sizes:[
{women:"5.5",eur:"36",insoleCm:23.4,outsoleCm:25.0},
{women:"6",eur:"37",insoleCm:24.1,outsoleCm:25.7},
{men:"5",women:"7",eur:"38",insoleCm:24.7,outsoleCm:26.3},
{men:"6",women:"8",eur:"39",insoleCm:25.4,outsoleCm:27.0},
{men:"7",women:"9",eur:"40",insoleCm:26.0,outsoleCm:27.7},
{men:"7.5",women:"10",eur:"41",insoleCm:26.7,outsoleCm:28.1},
{men:"8.5",women:"11",eur:"42",insoleCm:27.3,outsoleCm:28.8},
{men:"9.5",eur:"43",insoleCm:28.0,outsoleCm:29.8},
{men:"10",eur:"44",insoleCm:28.6,outsoleCm:30.5},
{men:"11",eur:"45",insoleCm:29.3,outsoleCm:31.0},
{men:"12",eur:"46",insoleCm:29.9,outsoleCm:31.5},
{men:"13",eur:"47",insoleCm:30.6,outsoleCm:32.5},
{men:"14",eur:"48",insoleCm:31.2,outsoleCm:33.0}
]
},
lowline_sneakers_subliminator:{
  type:"footwear",
  label:"Lowline Sneakers",
  measurementMode:"foot_length",
  toeRoom:{
    snug:0.35,
    comfortable:0.50,
    roomy:0.70
  },
  sockAllowance:0.10,
sizes:[
{women:"5",eur:"35",insoleCm:22.8,outsoleCm:24.4},
{women:"5.5",eur:"36",insoleCm:23.4,outsoleCm:25.0},
{women:"6",eur:"37",insoleCm:24.1,outsoleCm:25.7},
{men:"5",women:"7",eur:"38",insoleCm:24.7,outsoleCm:26.3},
{men:"6",women:"8",eur:"39",insoleCm:25.4,outsoleCm:27.0},
{men:"7",women:"9",eur:"40",insoleCm:26.0,outsoleCm:27.7},
{men:"7.5",women:"10",eur:"41",insoleCm:26.7,outsoleCm:28.1},
{men:"8.5",women:"11",eur:"42",insoleCm:27.3,outsoleCm:28.8},
{men:"9.5",women:"11.5",eur:"43",insoleCm:28.0,outsoleCm:29.8},
{men:"10",women:"12",eur:"44",insoleCm:28.6,outsoleCm:30.5},
{men:"11",eur:"45",insoleCm:29.3,outsoleCm:31.0},
{men:"12",eur:"46",insoleCm:29.9,outsoleCm:31.5},
{men:"13",eur:"47",insoleCm:30.6,outsoleCm:32.5},
{men:"14",eur:"48",insoleCm:31.2,outsoleCm:33.0}
]
},
tr_sneakers_popcustoms:{
type:"footwear",
label:"TR Sneakers",
measurementMode:"insole_reference",
variantFormat:"us_eu_parentheses",
sizes:[
{women:"5.5",eur:"36",insoleCm:23.9},
{women:"6",eur:"37",insoleCm:24.5},
{women:"7",eur:"38",insoleCm:25.2},
{women:"8",eur:"39",insoleCm:25.8},
{women:"9",eur:"40",insoleCm:26.5},
{women:"10",eur:"41",insoleCm:27.1},
{women:"11",eur:"42",insoleCm:27.8},
{women:"11.5",eur:"43",insoleCm:28.4},
{women:"12",eur:"44",insoleCm:29.1}
]
},
womens_low_top_sneakers_popcustoms:{
type:"footwear",
label:"Low-Top Sneakers",
measurementMode:"insole_reference",
variantFormat:"us_eu_parentheses",
sizes:[
{women:"5.5",eur:"36",insoleCm:23.9},
{women:"6",eur:"37",insoleCm:24.5},
{women:"7",eur:"38",insoleCm:25.2},
{women:"8",eur:"39",insoleCm:25.8},
{women:"9",eur:"40",insoleCm:26.5},
{women:"10",eur:"41",insoleCm:27.1},
{women:"11",eur:"42",insoleCm:27.8},
{women:"11.5",eur:"43",insoleCm:28.4},
{women:"12",eur:"44",insoleCm:29.1}
]
},
canvas_slip_on:{
type:"footwear",
label:"Canvas Slip-On",
measurementMode:"foot_length",
variantSystem:"women_us",
toeRoom:{
snug:0,
comfortable:0,
roomy:0
},
sockAllowance:0,
sizes:[
{women:"5",uk:"2.5",eur:"35.5",insoleCm:21.92},
{women:"5.5",uk:"3",eur:"36",insoleCm:22.56},
{women:"6",uk:"3.5",eur:"36.5",insoleCm:22.86},
{women:"6.5",uk:"4",eur:"37",insoleCm:23.19},
{women:"7",uk:"4.5",eur:"38",insoleCm:23.50},
{men:"6",women:"7.5",uk:"5",eur:"38.5",insoleCm:24.13},
{men:"6.5",women:"8",uk:"5.5",eur:"39",insoleCm:24.46},
{men:"7",women:"8.5",uk:"6",eur:"40",insoleCm:24.77},
{men:"7.5",women:"9",uk:"6.5",eur:"40.5",insoleCm:25.40},
{men:"8",women:"9.5",uk:"7",eur:"41",insoleCm:25.73},
{men:"8.5",women:"10",uk:"7.5",eur:"42",insoleCm:26.04},
{men:"9",women:"10.5",uk:"8",eur:"42.5",insoleCm:26.67},
{men:"9.5",women:"11",uk:"8.5",eur:"43",insoleCm:27.00},
{men:"10",women:"11.5",uk:"9",eur:"44",insoleCm:27.31},
{men:"10.5",women:"12",uk:"9.5",eur:"44.5",insoleCm:27.94},
{men:"11",uk:"10",eur:"45",insoleCm:28.58},
{men:"11.5",uk:"10.5",eur:"46",insoleCm:29.21},
{men:"12",uk:"11",eur:"46.5",insoleCm:29.85},
{men:"12.5",uk:"11.5",eur:"47",insoleCm:30.18},
{men:"13",uk:"12",eur:"47.5",insoleCm:30.63}
]
},
womens_longline_hoodie:{
  type:"clothing_width",
  label:"Women’s Longline Hoodie",
  garmentType:"longline_hoodie",
  allowSizeUp:true,
  hint:
    "Lay a hoodie that fits you well flat and measure straight across the chest from side to side. Use the single-side ½ chest measurement — do not double it.",
  sizes:[
    {size:"XS",widthIn:16.5,lengthIn:29,sleeveIn:26},
    {size:"S",widthIn:17.5,lengthIn:30,sleeveIn:26.5},
    {size:"M",widthIn:18.5,lengthIn:31,sleeveIn:27},
    {size:"L",widthIn:19.5,lengthIn:32,sleeveIn:27.5},
    {size:"XL",widthIn:20.5,lengthIn:33,sleeveIn:28},
    {size:"2XL",widthIn:21.5,lengthIn:34,sleeveIn:28.5}
  ]
},
womens_flare_leggings:{
  type:"clothing_bottom_flat",
  label:"Women’s Flare Leggings",
  garmentType:"flare_leggings",
  allowSizeUp:true,
  hint:
    "Lay a pair of leggings that fits you well flat. Measure straight across the waistband and across the widest part of the hips. Use the single-side measurements — do not double them.",
  sizes:[
    {size:"XS",waistIn:11.5,hipIn:13.25,inseamIn:31,riseIn:8,totalLengthIn:39.5},
    {size:"S",waistIn:12.25,hipIn:14,inseamIn:32,riseIn:8.5,totalLengthIn:41},
    {size:"M",waistIn:13,hipIn:14.75,inseamIn:32,riseIn:9,totalLengthIn:41.5},
    {size:"L",waistIn:14.25,hipIn:16,inseamIn:33,riseIn:9.5,totalLengthIn:43},
    {size:"XL",waistIn:15.5,hipIn:17.25,inseamIn:33,riseIn:10,totalLengthIn:43.5},
    {size:"2XL",waistIn:16.75,hipIn:18.5,inseamIn:33.5,riseIn:10.5,totalLengthIn:44.5},
    {size:"3XL",waistIn:18,hipIn:19.75,inseamIn:33.5,riseIn:11,totalLengthIn:45}
  ]
},
unisex_low_top_canvas_printy6:{
type:"footwear",
label:"Unisex Low Top Canvas Shoes",
measurementMode:"insole_reference",
narrowFit:true,
sizes:[
{men:"3",women:"4.5",uk:"2.5",eur:"35",insoleCm:22.4},
{men:"3.5",women:"5",uk:"3",eur:"35.5",insoleCm:23.1},
{men:"4",women:"5.5",uk:"3.5",eur:"36",insoleCm:23.5},
{men:"5",women:"6.5",uk:"4.5",eur:"37",insoleCm:24.3},
{men:"5.5",women:"7",uk:"5",eur:"38",insoleCm:24.8},
{men:"6.5",women:"8",uk:"6",eur:"39",insoleCm:25.2},
{men:"7",women:"8.5",uk:"6",eur:"40",insoleCm:26.0},
{men:"8",women:"9.5",uk:"7",eur:"41",insoleCm:26.9},
{men:"8.5",women:"10",uk:"7.5",eur:"42",insoleCm:27.3},
{men:"9.5",women:"11",uk:"8.5",eur:"43",insoleCm:28.1},
{men:"10",women:"11.5",uk:"9",eur:"44",insoleCm:28.6},
{men:"11",women:"12.5",uk:"10",eur:"45",insoleCm:29.4},
{men:"12",women:"13.5",uk:"11",eur:"46",insoleCm:30.3},
{men:"12.5",women:"14",uk:"11.5",eur:"47",insoleCm:30.7}
]
},
unisex_s1_sneakers:{
type:"footwear",
label:"Unisex S-1 Sneakers",
measurementMode:"insole_reference",
sizes:[
{men:"3",women:"4.5",uk:"2.5",eur:"35",insoleCm:22.5},
{men:"4",women:"5.5",uk:"3.5",eur:"36",insoleCm:23.2},
{men:"5",women:"6.5",uk:"4.5",eur:"37",insoleCm:23.8},
{men:"5.5",women:"7",uk:"5",eur:"38",insoleCm:24.5},
{men:"6.5",women:"8",uk:"6",eur:"39",insoleCm:25.2},
{men:"7",women:"8.5",uk:"6",eur:"40",insoleCm:25.8},
{men:"8",women:"9.5",uk:"7",eur:"41",insoleCm:26.5},
{men:"8.5",women:"10",uk:"7.5",eur:"42",insoleCm:27.2},
{men:"9.5",women:"11",uk:"8.5",eur:"43",insoleCm:27.8},
{men:"10",women:"11.5",uk:"9",eur:"44",insoleCm:28.5},
{men:"11",women:"12.5",uk:"10",eur:"45",insoleCm:29.1},
{men:"12",women:"13.5",uk:"11",eur:"46",insoleCm:29.8},
{men:"12.5",women:"14",uk:"11.5",eur:"47",insoleCm:30.5},
{men:"13.5",women:"15",uk:"12.5",eur:"48",insoleCm:31.2}
]
},
city_boots:{
type:"footwear",
label:"City Boots",
measurementMode:"insole_reference",
variantSystem:"women_men_prefix",
sizes:[
{women:"5",men:"3",eur:"35",insoleCm:22.8,outsoleCm:24.4},
{women:"5.5",men:"4",eur:"36",insoleCm:23.4,outsoleCm:25.0},
{women:"6",men:"4.5",eur:"37",insoleCm:24.1,outsoleCm:25.7},
{women:"7",men:"5",eur:"38",insoleCm:24.7,outsoleCm:26.3},
{women:"8",men:"6",eur:"39",insoleCm:25.4,outsoleCm:27.0},
{women:"9",men:"7",eur:"40",insoleCm:26.0,outsoleCm:27.7},
{women:"10",men:"7.5",eur:"41",insoleCm:26.7,outsoleCm:28.1},
{women:"11",men:"8.5",eur:"42",insoleCm:27.3,outsoleCm:28.8},
{women:"11.5",men:"9.5",eur:"43",insoleCm:28.0,outsoleCm:29.8},
{women:"12",men:"10",eur:"44",insoleCm:28.6,outsoleCm:30.5},
{women:"12.5",men:"11",eur:"45",insoleCm:29.3,outsoleCm:31.0},
{women:"13.5",men:"12",eur:"46",insoleCm:29.9,outsoleCm:31.5},
{women:"14.5",men:"13",eur:"47",insoleCm:30.6,outsoleCm:32.5},
{women:"15.5",men:"14",eur:"48",insoleCm:31.2,outsoleCm:33.0}
]
},
womens_scoop_neck_skater_dress:{
type:"clothing_flat",
label:"Women’s Scoop Neck Skater Dress",
allowSizeUp:true,
hint:
"Lay a similar dress flat and measure straight across the bust and waist. Use the single-side measurements — do not double them.",
sizes:[
{size:"XS",bustIn:14.25,waistIn:11.5,hipIn:26,lengthIn:31.25},
{size:"S",bustIn:15.25,waistIn:12.5,hipIn:27,lengthIn:32.25},
{size:"M",bustIn:16.25,waistIn:13.5,hipIn:28,lengthIn:33.5},
{size:"L",bustIn:17.25,waistIn:14.5,hipIn:29,lengthIn:34.5},
{size:"XL",bustIn:18.25,waistIn:15.5,hipIn:30,lengthIn:35.75},
{size:"XXL",bustIn:19.25,waistIn:16.5,hipIn:31,lengthIn:37}
]
},
womens_light_weight_jacket:{
type:"clothing_width",
label:"Women’s Light Weight Jacket",
garmentType:"jacket",
allowSizeUp:true,
hint:
"Lay a jacket that fits you well flat and measure straight across the body. Use the single-side width — do not double it.",
sizes:[
{size:"XS",widthIn:19.75,lengthIn:23.5,sleeveIn:28},
{size:"S",widthIn:20.75,lengthIn:24.25,sleeveIn:29},
{size:"M",widthIn:21.75,lengthIn:25,sleeveIn:30},
{size:"L",widthIn:22.75,lengthIn:25.75,sleeveIn:31},
{size:"XL",widthIn:23.75,lengthIn:26,sleeveIn:32},
{size:"2XL",widthIn:24.75,lengthIn:27.25,sleeveIn:33}
]
},
womens_microfleece_cloak:{
type:"clothing_width",
label:"Microfleece Cloak",
garmentType:"cloak",
allowSizeUp:true,
hint:
"Lay a similar hoodie, jacket, or cloak that already fits you well flat. Measure straight across the chest from side to side. Use the single-side measurement — do not double it.",
sizes:[
{size:"XS",widthIn:21,lengthIn:32.5,sleeveIn:25.75},
{size:"S",widthIn:22,lengthIn:33.5,sleeveIn:26.375},
{size:"M",widthIn:23,lengthIn:34.5,sleeveIn:27},
{size:"L",widthIn:24,lengthIn:35.5,sleeveIn:27.625},
{size:"XL",widthIn:25,lengthIn:36.5,sleeveIn:28.25},
{size:"2XL",widthIn:26,lengthIn:37.5,sleeveIn:28.875},
{size:"3XL",widthIn:27,lengthIn:38.5,sleeveIn:29.5},
{size:"4XL",widthIn:28,lengthIn:39.5,sleeveIn:30.125}
]
},
womens_microfleece_hoodie:{
type:"clothing_width",
label:"Microfleece Hoodie",
garmentType:"hoodie",
allowSizeUp:true,
hint:
"Lay a similar hoodie that already fits you well flat. Measure straight across the chest from side to side. Use the single-side measurement — do not double it.",
sizes:[
{size:"XS",widthIn:20.5,lengthIn:26.5,sleeveIn:25.5},
{size:"S",widthIn:22,lengthIn:28,sleeveIn:26.5},
{size:"M",widthIn:23.5,lengthIn:29,sleeveIn:27.5},
{size:"L",widthIn:24.5,lengthIn:30,sleeveIn:28.5},
{size:"XL",widthIn:25.5,lengthIn:30.75,sleeveIn:29.5},
{size:"2XL",widthIn:26.5,lengthIn:31.5,sleeveIn:30},
{size:"3XL",widthIn:27.5,lengthIn:32.25,sleeveIn:30.5},
{size:"4XL",widthIn:28.5,lengthIn:33,sleeveIn:31}
]
},
womens_v_neck_tee:{
type:"clothing_width",
label:"Women’s V-Neck Tee",
garmentType:"tee",
allowSizeUp:false,
hint:
"Lay a tee that fits you well flat and measure straight across the body. Use the single-side measurement — do not double it.",
sizes:[
{size:"XS",widthIn:17.25,lengthIn:24.5},
{size:"S",widthIn:18.25,lengthIn:25.25},
{size:"M",widthIn:19.25,lengthIn:26},
{size:"L",widthIn:20.25,lengthIn:26.75},
{size:"XL",widthIn:21.25,lengthIn:27.5},
{size:"2XL",widthIn:22.25,lengthIn:28.25}
]
},
unisex_t_shirt:{
type:"clothing_width",
label:"Unisex T-Shirt",
garmentType:"unisex_tee",
allowSizeUp:true,
hint:
"Lay a T-shirt that fits you well flat. Measure straight across the chest about 1 inch below the armhole. Use the single-side measurement — do not double it.",
sizes:[
{size:"XS",widthIn:18.5,lengthIn:27.5},
{size:"S",widthIn:19.5,lengthIn:28.5},
{size:"M",widthIn:20.5,lengthIn:29.5},
{size:"L",widthIn:21.5,lengthIn:30.5},
{size:"XL",widthIn:22.5,lengthIn:31.5},
{size:"2XL",widthIn:23.5,lengthIn:32.5},
{size:"3XL",widthIn:24.5,lengthIn:33.5},
{size:"4XL",widthIn:25.5,lengthIn:34.5}
]
},
womens_bodysuit_subliminator:{
type:"clothing_body",
label:"Women’s Bodysuit",
allowSizeUp:true,
hint:
"Use your bust, waist, and hip measurements. This style is designed for a close, body-hugging fit. If you prefer a little more breathing room, choose the roomier option.",
sizes:[
{size:"XS",bustIn:33.25,waistIn:25.25,hipIn:35.5},
{size:"S",bustIn:34.5,waistIn:26.75,hipIn:37},
{size:"M",bustIn:36.25,waistIn:28.5,hipIn:38.5},
{size:"L",bustIn:37.75,waistIn:29.75,hipIn:40.25},
{size:"XL",bustIn:41,waistIn:33.25,hipIn:43.25}
]
},
womens_2_piece_soccer_set:{
type:"clothing_set_flat",
label:"Women’s 2-Piece Soccer Set",
allowSizeUp:true,
hint:
"Use a similar athletic top and pair of shorts that already fit you well. Lay them flat and measure the top across the chest, then the bottoms across the waist and hips. Do not double the measurements.",
sizes:[
{size:"XS",chestIn:16.5,waistIn:13,hipIn:19,frontLengthIn:24.75,backLengthIn:25.5,inseamIn:3.75},
{size:"S",chestIn:17.75,waistIn:14,hipIn:20.5,frontLengthIn:25.25,backLengthIn:26,inseamIn:3.75},
{size:"M",chestIn:19,waistIn:15,hipIn:22,frontLengthIn:25.75,backLengthIn:26.5,inseamIn:3.75},
{size:"L",chestIn:20.5,waistIn:16,hipIn:23.5,frontLengthIn:26.25,backLengthIn:27,inseamIn:3.75},
{size:"XL",chestIn:22,waistIn:17,hipIn:25,frontLengthIn:27,backLengthIn:27.75,inseamIn:4},
{size:"2XL",chestIn:23.25,waistIn:18,hipIn:26.5,frontLengthIn:27.75,backLengthIn:28.5,inseamIn:4},
{size:"3XL",chestIn:24.5,waistIn:19,hipIn:28,frontLengthIn:28.5,backLengthIn:29.25,inseamIn:4}
]
},
womens_silk_pajamas:{
type:"clothing_set_flat",
label:"Women’s Silk Pajamas",
allowSizeUp:true,
hint:
"Use a pajama top and bottoms that already fit you well. Lay them flat and measure the top across the chest, then the bottoms across the waist and hips. Do not double the measurements.",
sizes:[
{size:"XS/S",chestIn:19,waistIn:14.5,hipIn:21.25,frontLengthIn:25,sleeveLengthIn:22,inseamIn:30,bottomLengthIn:40.5},
{size:"M/L",chestIn:20.25,waistIn:15.5,hipIn:22.5,frontLengthIn:26,sleeveLengthIn:22.5,inseamIn:30,bottomLengthIn:41},
{size:"XL/2XL",chestIn:21.5,waistIn:16.5,hipIn:23.75,frontLengthIn:27,sleeveLengthIn:23,inseamIn:30,bottomLengthIn:41.375},
{size:"3XL/4XL",chestIn:22.75,waistIn:17.5,hipIn:25,frontLengthIn:28,sleeveLengthIn:23.5,inseamIn:30,bottomLengthIn:42.75}
]
},
unisex_joggers:{
type:"clothing_bottom_flat",
label:"Unisex Joggers",
allowSizeUp:true,
hint:
"Lay a pair of joggers that already fits you well flat. Measure straight across the waist and hips. Use the single-side measurements — do not double them.",
sizes:[
{size:"XS",waistIn:14,hipIn:17.5,inseamIn:25,totalLengthIn:35},
{size:"S",waistIn:15,hipIn:19,inseamIn:26,totalLengthIn:36.5},
{size:"M",waistIn:16,hipIn:20.5,inseamIn:27,totalLengthIn:38},
{size:"L",waistIn:17.5,hipIn:22,inseamIn:28,totalLengthIn:39.5},
{size:"XL",waistIn:19,hipIn:23.5,inseamIn:29,totalLengthIn:41},
{size:"2XL",waistIn:20.5,hipIn:25,inseamIn:29.5,totalLengthIn:42},
{size:"3XL",waistIn:21,hipIn:26.5,inseamIn:30,totalLengthIn:43},
{size:"4XL",waistIn:22,hipIn:28,inseamIn:30.5,totalLengthIn:44}
]
},
womens_loose_shorts:{
type:"clothing_bottom_flat",
label:"Loose Shorts",
allowSizeUp:false,
hint:
"Lay a similar pair of shorts that already fits you well flat. Measure straight across the waist and hips. Use the single-side measurements — do not double them.",
sizes:[
{size:"XS",waistIn:14,hipIn:20,inseamIn:3,totalLengthIn:11.5},
{size:"S",waistIn:15,hipIn:21,inseamIn:3,totalLengthIn:12},
{size:"M",waistIn:16,hipIn:22,inseamIn:3.5,totalLengthIn:13},
{size:"L",waistIn:17,hipIn:23,inseamIn:3.5,totalLengthIn:13.5},
{size:"XL",waistIn:18,hipIn:24,inseamIn:4,totalLengthIn:14.5},
{size:"2XL",waistIn:19,hipIn:25,inseamIn:4,totalLengthIn:15},
{size:"3XL",waistIn:20,hipIn:26,inseamIn:4,totalLengthIn:15.5}
]
},
womens_plus_size_leggings:{
type:"clothing_bottom_flat",
label:"Plus Size Leggings",
garmentType:"leggings",
allowSizeUp:true,
hint:
"Lay a similar pair of leggings that already fits you well flat. Measure straight across the waist and hips. Use the single-side measurements — do not double them.",
sizes:[
{size:"2XL",waistIn:15,hipIn:19.5,inseamIn:28.5},
{size:"3XL",waistIn:15.75,hipIn:21,inseamIn:28.75},
{size:"4XL",waistIn:17,hipIn:22.5,inseamIn:29.25},
{size:"5XL",waistIn:18.5,hipIn:24,inseamIn:29.5},
{size:"6XL",waistIn:20,hipIn:25.5,inseamIn:29.5}
]
},
womens_cropped_short_sleeve_sweatshirt:{
type:"clothing_top_flat",
label:"Cropped Short Sleeve Sweatshirt",
allowSizeUp:true,
hint:
"Lay a similar top that already fits you well flat. Measure straight across the chest about 1 inch below the armhole, then across the relaxed waistband. Use the single-side measurements — do not double them.",
sizes:[
{size:"XS",chestIn:14.5,waistbandIn:11,frontLengthIn:16.5},
{size:"S",chestIn:15.5,waistbandIn:12,frontLengthIn:17.25},
{size:"M",chestIn:16.5,waistbandIn:13,frontLengthIn:18},
{size:"L",chestIn:17.5,waistbandIn:14,frontLengthIn:18.75},
{size:"XL",chestIn:18.5,waistbandIn:15,frontLengthIn:19.5}
]
},
womens_leggings:{
type:"clothing_bottom_flat",
label:"Women’s Leggings",
garmentType:"leggings",
allowSizeUp:true,
hint:
"Lay a similar pair of leggings that already fits you well flat. Measure straight across the waist and hips. Use the single-side measurements — do not double them.",
sizes:[
{size:"XS",waistIn:11.8,hipIn:12.4,inseamIn:27.125,totalLengthIn:34.625},
{size:"S",waistIn:12.4,hipIn:13,inseamIn:27.125,totalLengthIn:35.125},
{size:"M",waistIn:13,hipIn:14,inseamIn:27.125,totalLengthIn:35.125},
{size:"L",waistIn:14,hipIn:16,inseamIn:27.125,totalLengthIn:35.125},
{size:"XL",waistIn:15,hipIn:17,inseamIn:27.125,totalLengthIn:36},
{size:"2XL",waistIn:17,hipIn:18,inseamIn:27.125,totalLengthIn:36},
{size:"3XL",waistIn:18.25,hipIn:20,inseamIn:27.125,totalLengthIn:37}
]
},
womens_triangle_string_bikini:{
type:"clothing_bikini_flat",
label:"Women’s Triangle String Bikini",
garmentType:"bikini",
allowSizeUp:true,
hint:
"Lay a similar triangle bikini that fits you well flat. Measure the cup width and height, then the front and back rise of the bottoms. Use the flat garment measurements — do not double them.",
sizes:[
{size:"XS",cupWidthIn:7.5,cupHeightIn:6.5,frontRiseIn:8.5,backRiseIn:8.25},
{size:"S",cupWidthIn:8,cupHeightIn:6.75,frontRiseIn:9,backRiseIn:8.75},
{size:"M",cupWidthIn:8.5,cupHeightIn:7.25,frontRiseIn:9.25,backRiseIn:8.75},
{size:"L",cupWidthIn:9,cupHeightIn:7.5,frontRiseIn:9.75,backRiseIn:9.5},
{size:"XL",cupWidthIn:9.5,cupHeightIn:8,frontRiseIn:10.25,backRiseIn:10},
{size:"2XL",cupWidthIn:10,cupHeightIn:8.5,frontRiseIn:10.75,backRiseIn:10.75}
]
},
womens_hoodie_dress:{
type:"clothing_width",
label:"Women’s Hoodie Dress",
garmentType:"hoodie_dress",
allowSizeUp:true,
hint:
"Lay a similar hoodie or dress that already fits you well flat. Measure straight across the chest from side to side. Use the single-side measurement — do not double it.",
sizes:[
{size:"S",widthIn:18.1,lengthIn:33.1,sleeveIn:18.5},
{size:"M",widthIn:19.3,lengthIn:33.9,sleeveIn:18.9},
{size:"L",widthIn:20.45,lengthIn:34.6,sleeveIn:19.3},
{size:"XL",widthIn:21.65,lengthIn:35.4,sleeveIn:19.7},
{size:"2XL",widthIn:22.85,lengthIn:36.2,sleeveIn:20.1}
]
},
womens_track_pants:{
type:"clothing_bottom_flat",
label:"Women’s Track Pants",
garmentType:"track_pants",
allowSizeUp:true,
hint:
"Lay a similar pair of track pants that already fits you well flat. Measure straight across the waist and hips. Use the single-side measurements — do not double them.",
sizes:[
{size:"XS",waistIn:12,hipIn:20.25,inseamIn:28.75,totalLengthIn:38},
{size:"S",waistIn:13,hipIn:21.25,inseamIn:29,totalLengthIn:39},
{size:"M",waistIn:14.25,hipIn:22.25,inseamIn:29.5,totalLengthIn:39.75},
{size:"L",waistIn:15.5,hipIn:23.25,inseamIn:30,totalLengthIn:40.5},
{size:"XL",waistIn:16.25,hipIn:24.25,inseamIn:30.25,totalLengthIn:41.25},
{size:"2XL",waistIn:17.5,hipIn:25.25,inseamIn:30.75,totalLengthIn:42}
]
},
womens_ruffle_sleeve_top:{
type:"clothing_width",
label:"Women’s Ruffle Sleeve Top",
garmentType:"ruffle_top",
allowSizeUp:true,
hint:
"Lay a similar top that already fits you well flat. Measure straight across the body from side to side. Use the single-side measurement — do not double it.",
sizes:[
{size:"XS",widthIn:17.5,lengthIn:25.25},
{size:"S",widthIn:18.5,lengthIn:26.25},
{size:"M",widthIn:19.5,lengthIn:27.25},
{size:"L",widthIn:20.75,lengthIn:28.25},
{size:"XL",widthIn:22.25,lengthIn:29.25},
{size:"2XL",widthIn:23.75,lengthIn:29.25}
]
},
womens_cropped_windbreaker:{
type:"clothing_width",
label:"Women’s Cropped Windbreaker",
garmentType:"cropped_windbreaker",
allowSizeUp:true,
hint:
"Lay a similar jacket or windbreaker that already fits you well flat. Measure straight across the body from side to side. Use the single-side measurement — do not double it.",
sizes:[
{size:"XS",widthIn:22,lengthIn:19.25,sleeveIn:28.75},
{size:"S",widthIn:23,lengthIn:20,sleeveIn:29.5},
{size:"M",widthIn:24,lengthIn:20.75,sleeveIn:30.25},
{size:"L",widthIn:25,lengthIn:21.5,sleeveIn:31},
{size:"XL",widthIn:26,lengthIn:22.25,sleeveIn:31.75},
{size:"XXL",widthIn:27,lengthIn:23,sleeveIn:32.5}
]
},
unisex_fashion_hoodie:{
  type:"clothing_width",
  label:"Fashion Hoodie",
  garmentType:"fashion_hoodie",
  allowSizeUp:true,
  hint:
    "Lay a hoodie that fits you well flat and measure straight across the chest from side to side. Use the single-side measurement — do not double it.",
  sizes:[
    {size:"XS",widthIn:19.25,lengthIn:25.5,sleeveIn:23.75},
    {size:"S",widthIn:20.75,lengthIn:27,sleeveIn:25.75},
    {size:"M",widthIn:22.25,lengthIn:28.5,sleeveIn:26.75},
    {size:"L",widthIn:23.75,lengthIn:29.5,sleeveIn:27.75},
    {size:"XL",widthIn:24.75,lengthIn:30.5,sleeveIn:28.75},
    {size:"2XL",widthIn:25.75,lengthIn:31.25,sleeveIn:29.75},
    {size:"3XL",widthIn:26.75,lengthIn:32,sleeveIn:30.75},
    {size:"4XL",widthIn:27.75,lengthIn:32.75,sleeveIn:30.75}
  ]
},
womens_rashguard:{
  type:"clothing_width",
  label:"Women’s Rashguard",
  garmentType:"rashguard",
  allowSizeUp:true,
  hint:
    "Lay a fitted top or rashguard that already fits you well flat and measure straight across the chest from side to side. Use the single-side ½ chest measurement — do not double it.",
  sizes:[
    {size:"XS",widthIn:14.25,lengthIn:26.25,sleeveIn:27.75},
    {size:"S",widthIn:15,lengthIn:26.75,sleeveIn:28.125},
    {size:"M",widthIn:15.75,lengthIn:27,sleeveIn:28.5},
    {size:"L",widthIn:17.5,lengthIn:27.5,sleeveIn:29},
    {size:"XL",widthIn:19,lengthIn:28,sleeveIn:29.25},
    {size:"2XL",widthIn:20,lengthIn:28.5,sleeveIn:29.75},
    {size:"3XL",widthIn:21.5,lengthIn:28.75,sleeveIn:30},
    {size:"4XL",widthIn:22.5,lengthIn:29,sleeveIn:30.5}
  ]
},
};
function qs(root, selector){
return root ? root.querySelector(selector) : null;
}
function qsa(root, selector){
return root
? Array.prototype.slice.call(root.querySelectorAll(selector))
: [];
}
function normalize(value){
return String(value || "")
.toLowerCase()
.replace(/women'?s?/g, "")
.replace(/men'?s?/g, "")
.replace(/unisex/g, "")
.replace(/size/g, "")
.replace(/\s+/g, "")
.replace(/[–—]/g, "-");
}
function cmToIn(cm){
return cm / 2.54;
}
function inToCm(inches){
return inches * 2.54;
}
function round(value, decimals){
var p = Math.pow(10, decimals || 1);
return Math.round(value * p) / p;
}
function valueToInches(value, unit){
return unit === "cm"
? cmToIn(value)
: value;
}
function valueToCm(value, unit){
return unit === "in"
? inToCm(value)
: value;
}
function escapeHtml(value){
return String(value == null ? "" : value)
.replace(/&/g,"&amp;")
.replace(/</g,"&lt;")
.replace(/>/g,"&gt;")
.replace(/"/g,"&quot;")
.replace(/'/g,"&#039;");
}
function unique(values){
var seen = {};
return values.filter(function(v){
var key = normalize(v);
if(!key || seen[key]){
return false;
}
seen[key] = true;
return true;
});
}
function showScreen(root, target){
var intro =
qs(root, '[data-p817-screen="intro"]');
var form =
qs(root, "[data-p817-form]");
var result =
qs(root, "[data-p817-result]");
if(intro){
intro.hidden =
target !== "intro";
}
if(form){
form.hidden =
target !== "form";
}
if(result){
result.hidden =
target !== "result";
}
}
function showStep(root, step){
qsa(
root,
"[data-p817-step]"
).forEach(function(el){
el.hidden =
Number(
el.getAttribute(
"data-p817-step"
)
) !== step;
});
var label =
qs(root, "[data-p817-step-label]");
if(label){
label.textContent =
"Step " + step + " of 3";
}
var progress =
qs(root, "[data-p817-progress]");
if(progress){
progress.style.width =
((step / 3) * 100) + "%";
}
var back =
qs(root, "[data-p817-back]");
if(back){
back.style.visibility =
step > 1
? "visible"
: "hidden";
}
}
function setupChoices(root){
qsa(
root,
".p817-sf__choice input[type='radio']"
).forEach(function(input){
input.addEventListener(
"change",
function(){
var name =
input.name;
qsa(
root,
'input[name="' + name + '"]'
).forEach(function(other){
var label =
other.closest(
".p817-sf__choice"
);
if(label){
label.classList.toggle(
"is-selected",
other.checked
);
}
});
}
);
});
}
function setupUnitButtons(
root,
state,
inputs
){
qsa(
root,
"[data-p817-unit]"
).forEach(function(button){
button.addEventListener(
"click",
function(){
var nextUnit =
button.getAttribute(
"data-p817-unit"
);
if(nextUnit === state.unit){
return;
}
inputs.forEach(function(input){
if(
!input ||
input.value === ""
){
return;
}
var value =
parseFloat(input.value);
if(!isFinite(value)){
return;
}
if(nextUnit === "cm"){
input.value =
round(
inToCm(value),
2
);
} else {
input.value =
round(
cmToIn(value),
2
);
}
});
state.unit =
nextUnit;
qsa(
root,
"[data-p817-unit]"
).forEach(function(btn){
btn.classList.toggle(
"is-active",
btn.getAttribute(
"data-p817-unit"
) === nextUnit
);
});
qsa(
root,
"[data-p817-unit-label]"
).forEach(function(label){
label.textContent =
nextUnit;
});
}
);
});
}
function setupSteps(
root,
state,
validateStep
){
qsa(
root,
"[data-p817-next]"
).forEach(function(button){
button.addEventListener(
"click",
function(){
if(
validateStep &&
!validateStep(state.step)
){
return;
}
if(state.step < 3){
state.step += 1;
showStep(
root,
state.step
);
}
}
);
});
var back =
qs(root, "[data-p817-back]");
if(back){
back.addEventListener(
"click",
function(){
if(state.step > 1){
state.step -= 1;
showStep(
root,
state.step
);
}
}
);
}
}
function readFit(root){
var checked =
qs(
root,
'.p817-sf__choice input[type="radio"]:checked'
);
return checked
? checked.value
: "comfortable";
}
function showInputError(input){
if(!input){
return false;
}
var value =
parseFloat(input.value);
if(
!isFinite(value) ||
value <= 0
){
input.focus();
return false;
}
return true;
}
function clothingCandidates(size){
var raw =
String(size || "").trim();
var n =
normalize(raw);
var values =
[raw];
if(n === "xs"){
values.push(
"XS",
"Extra Small"
);
}
if(n === "s"){
values.push(
"S",
"Small"
);
}
if(n === "m"){
values.push(
"M",
"Medium"
);
}
if(n === "l"){
values.push(
"L",
"Large"
);
}
if(n === "xl"){
values.push(
"XL",
"X-Large",
"Extra Large"
);
}
if(
n === "2xl" ||
n === "xxl"
){
values.push(
"2XL",
"XXL",
"2X",
"2X-Large",
"Double XL"
);
}
if(
n === "3xl" ||
n === "xxxl"
){
values.push(
"3XL",
"XXXL",
"3X",
"3X-Large"
);
}
if(
n === "4xl" ||
n === "xxxxl"
){
values.push(
"4XL",
"XXXXL",
"4X",
"4X-Large"
);
}
if(n === "5xl"){
values.push(
"5XL",
"5X",
"5X-Large"
);
}
if(n === "6xl"){
values.push(
"6XL",
"6X",
"6X-Large"
);
}
return unique(values);
}
function footwearStoreSize(row, profile){

  if(
    profile &&
    profile.variantSystem === "vegan_boots_flexible"
  ){
    if(row.men && row.women){
      return row.men + " Men / " + row.women + " Women";
    }

    if(row.women){
      return row.women + " Women US";
    }

    if(row.men){
      return row.men + " Men US";
    }
  }

  if(
    profile &&
    profile.variantSystem === "women_us" &&
    row.women
  ){
    return row.women + " Women US";
  }

  if(
    profile &&
    profile.variantSystem === "women_men_prefix" &&
    row.women &&
    row.men
  ){
    return "W " + row.women + " / M " + row.men;
  }

  if(
    profile &&
    profile.variantFormat === "us_eu_parentheses" &&
    row.women &&
    row.eur
  ){
    return "US" + row.women + " (EU" + row.eur + ")";
  }

  var parts = [];

  if(row.men){
    parts.push(
      row.men + "M"
    );
  }

  if(row.women){
    parts.push(
      row.women + "W"
    );
  }

  if(parts.length){
    return parts.join(" / ");
  }

  if(row.eur){
    return "EUR " + row.eur;
  }

  return "";
}
function footwearCandidates(row, profile){
  var values = [];

  /* =========================================================
     VEGAN LEATHER BOOTS — FLEXIBLE STOREFRONT

     Supports older and newer Shopify listings for the same
     Vegan Leather Boots product type.

     Examples:
     7 Men / 8.5 Women
     7M / 8.5W
     M 7 / W 8.5
     W 8.5 / M 7
     8.5 Women US
     8.5 Women
     ========================================================= */
  if(
    profile &&
    profile.variantSystem === "vegan_boots_flexible"
  ){
    if(row.men && row.women){
      values.push(
        row.men + " Men / " + row.women + " Women",
        row.men + " Men/" + row.women + " Women",
        row.men + " Men / " + row.women + " Women US",
        row.men + " Men/" + row.women + " Women US",

        row.women + " Women / " + row.men + " Men",
        row.women + " Women/" + row.men + " Men",

        row.men + "M / " + row.women + "W",
        row.men + " M / " + row.women + " W",
        row.men + "M/" + row.women + "W",

        "M " + row.men + " / W " + row.women,
        "M" + row.men + " / W" + row.women,
        "M " + row.men + "/W " + row.women,
        "M" + row.men + "/W" + row.women,

        row.women + "W / " + row.men + "M",
        row.women + " W / " + row.men + " M",
        row.women + "W/" + row.men + "M",

        "W " + row.women + " / M " + row.men,
        "W" + row.women + " / M" + row.men,
        "W " + row.women + "/M " + row.men,
        "W" + row.women + "/M" + row.men,

        row.men + " / " + row.women,
        row.men + "/" + row.women,
        row.women + " / " + row.men,
        row.women + "/" + row.men
      );
    }

    if(row.women){
      values.push(
        row.women + " Women US",
        row.women + " Women",
        "US Women " + row.women,
        "US " + row.women + " Women",
        "Women US " + row.women,
        "Women " + row.women,
        row.women + "W",
        row.women + " W",
        "W " + row.women,
        "W" + row.women
      );
    }

    if(row.men){
      values.push(
        row.men + " Men US",
        row.men + " Men",
        "US Men " + row.men,
        "US " + row.men + " Men",
        "Men US " + row.men,
        "Men " + row.men,
        row.men + "M",
        row.men + " M",
        "M " + row.men,
        "M" + row.men
      );
    }

    return unique(values);
  }


  /* =========================================================
     WOMEN'S US STOREFRONT
     Example Shopify option: 8.5 Women US

     IMPORTANT:
     When the storefront uses Women's US sizing, do NOT include
     Men's sizes as candidates. They are conversion info only.
     ========================================================= */
  if(
    profile &&
    profile.variantSystem === "women_us"
  ){
    if(row.women){
      values.push(
        row.women + " Women US",
        row.women + " Women",
        "US Women " + row.women,
        "US " + row.women + " Women",
        "Women US " + row.women,
        "Women " + row.women,
        row.women + "W",
        row.women + " W",
        "W " + row.women,
        "W" + row.women
      );
    }

    return unique(values);
  }


  /* =========================================================
     WOMEN / MEN COMBINED STOREFRONT
     Example Shopify option: W 8 / M 6

     Only compare against the combined storefront format.
     ========================================================= */
  if(
    profile &&
    profile.variantSystem === "women_men_prefix"
  ){
    if(
      row.women &&
      row.men
    ){
      values.push(
        "W " + row.women + " / M " + row.men,
        "W" + row.women + " / M" + row.men,
        "W " + row.women + "/M " + row.men,
        "W" + row.women + "/M" + row.men,
        "Women " + row.women + " / Men " + row.men,
        row.women + "W / " + row.men + "M",
        row.women + " W / " + row.men + " M"
      );
    }

    return unique(values);
  }


  /* =========================================================
     US / EU PARENTHESIS STOREFRONT
     Example Shopify option: US7 (EU38)

     Do not let unrelated Men/UK conversions interfere.
     ========================================================= */
  if(
    profile &&
    profile.variantFormat === "us_eu_parentheses"
  ){
    if(
      row.women &&
      row.eur
    ){
      values.push(
        "US" + row.women + " (EU" + row.eur + ")",
        "US " + row.women + " (EU " + row.eur + ")",
        "US" + row.women + "(EU" + row.eur + ")",
        "US " + row.women + " / EU " + row.eur,
        "US" + row.women + "/EU" + row.eur
      );
    }

    return unique(values);
  }


  /* =========================================================
     STANDARD / UNISEX FALLBACK
     ========================================================= */

  if(
    row.men &&
    row.women
  ){
    values.push(
      row.men + "M / " + row.women + "W",
      row.men + " M / " + row.women + " W",
      row.men + "M/" + row.women + "W",

      row.women + "W / " + row.men + "M",
      row.women + " W / " + row.men + " M",
      row.women + "W/" + row.men + "M",

      "M " + row.men + " / W " + row.women,
      "M" + row.men + " / W" + row.women,

      "W " + row.women + " / M " + row.men,
      "W" + row.women + " / M" + row.men,

      row.men + " / " + row.women,
      row.women + " / " + row.men
    );
  }


  if(row.women){
    values.push(
      row.women + "W",
      row.women + " W",
      "W " + row.women,
      "W" + row.women,
      "US Women " + row.women,
      "Women " + row.women,
      row.women + " Women US",
      row.women + " Women"
    );
  }


  if(row.men){
    values.push(
      row.men + "M",
      row.men + " M",
      "M " + row.men,
      "M" + row.men,
      "US Men " + row.men,
      "Men " + row.men,
      row.men + " Men US",
      row.men + " Men"
    );
  }


  if(row.eur){
    values.push(
      "EUR " + row.eur,
      "EUR" + row.eur,
      "EU " + row.eur,
      "EU" + row.eur
    );
  }


  if(row.uk){
    values.push(
      "UK " + row.uk,
      "UK" + row.uk,
      row.uk + " UK"
    );
  }


  return unique(values);
}
function setResult(root, data){
var resultSize =
qs(
root,
"[data-p817-result-size]"
);
var conversions =
qs(
root,
"[data-p817-result-conversions]"
);
var copy =
qs(
root,
"[data-p817-result-copy]"
);
var note =
qs(
root,
"[data-p817-result-note]"
);
if(resultSize){
resultSize.textContent =
data.size || "";
}
if(conversions){
conversions.innerHTML =
data.conversions || "";
}
if(copy){
copy.textContent =
data.copy || "";
}
if(note){
if(data.note){
note.hidden = false;
note.textContent =
data.note;
} else {
note.hidden = true;
note.textContent = "";
}
}
root.__p817Recommendation =
data;
showScreen(
root,
"result"
);
}
function elementText(el){
if(!el){
return "";
}
return (
el.getAttribute("data-value") ||
el.value ||
el.getAttribute("value") ||
el.getAttribute("aria-label") ||
el.textContent ||
""
).trim();
}
function cleanOptionText(value){
return String(value || "")
.replace(/\s+/g, " ")
.trim();
}
function rawUnique(values){
var seen = {};
return values
.map(cleanOptionText)
.filter(function(value){
if(!value){
return false;
}
var key =
value.toLowerCase();
if(seen[key]){
return false;
}
seen[key] = true;
return true;
});
}
function matchesCandidate(
value,
candidates
){
var target =
normalize(value);
return candidates.some(
function(candidate){
return (
normalize(candidate) ===
target
);
}
);
}
function dispatchChange(el){
if(!el){
return;
}
el.dispatchEvent(
new Event(
"input",
{bubbles:true}
)
);
el.dispatchEvent(
new Event(
"change",
{bubbles:true}
)
);
}
function optionLooksDisabled(el, label, option){
if(
option &&
option.disabled
){
return true;
}
if(
el &&
(
el.disabled ||
el.getAttribute("aria-disabled") === "true"
)
){
return true;
}
if(
label &&
(
label.getAttribute("aria-disabled") === "true" ||
label.classList.contains("disabled") ||
label.classList.contains("is-disabled") ||
label.classList.contains("soldout") ||
label.classList.contains("sold-out")
)
){
return true;
}
var disabledParent =
(
label &&
(
label.closest(".disabled") ||
label.closest(".is-disabled") ||
label.closest(".soldout") ||
label.closest(".sold-out") ||
label.closest("[aria-disabled='true']")
)
) ||
(
el &&
(
el.closest(".disabled") ||
el.closest(".is-disabled") ||
el.closest(".soldout") ||
el.closest(".sold-out") ||
el.closest("[aria-disabled='true']")
)
);
return !!disabledParent;
}
function getNativeOptionScope(root){
if(!root){
return document;
}
var section =
root.closest(
".shopify-section"
);
if(section){
return section;
}
var main =
root.closest(
"main"
);
return main || document;
}
function collectNativeOptionEntries(root){
var entries = [];
var seenElements = [];
var scope = getNativeOptionScope(root);
function addEntry(entry){
if(
!entry ||
!entry.element
){
return;
}
if(
root &&
root.contains(entry.element)
){
return;
}
if(
seenElements.indexOf(
entry.element
) !== -1
){
return;
}
entry.aliases =
rawUnique(
entry.aliases || []
);
if(!entry.aliases.length){
return;
}
entry.displayText =
cleanOptionText(
entry.displayText ||
entry.aliases[0]
);
if(!entry.displayText){
return;
}
seenElements.push(
entry.element
);
entries.push(entry);
}
Array.prototype.slice.call(
scope.querySelectorAll(
'input[type="radio"]'
)
).forEach(function(input){
if(
root &&
root.contains(input)
){
return;
}
var label = null;
if(input.id){
try{
label =
scope.querySelector(
'label[for="' +
CSS.escape(input.id) +
'"]'
);
} catch(err){
label = null;
}
}
if(!label){
label =
input.closest("label");
}
var labelText =
label
? cleanOptionText(
label.textContent
)
: "";
var valueText =
cleanOptionText(
input.value
);
var dataValue =
cleanOptionText(
input.getAttribute(
"data-value"
)
);
var ariaLabel =
cleanOptionText(
input.getAttribute(
"aria-label"
)
);
addEntry({
type:"radio",
element:input,
clickTarget:
label || input,
label:label,
aliases:[
labelText,
valueText,
dataValue,
ariaLabel
],
displayText:
labelText ||
dataValue ||
valueText ||
ariaLabel,
disabled:
optionLooksDisabled(
input,
label,
null
)
});
});
Array.prototype.slice.call(
scope.querySelectorAll(
"select"
)
).forEach(function(select){
if(
root &&
root.contains(select)
){
return;
}
Array.prototype.slice.call(
select.options || []
).forEach(function(option){
var text =
cleanOptionText(
option.textContent
);
var value =
cleanOptionText(
option.value
);
addEntry({
type:"select",
element:option,
select:select,
option:option,
aliases:[
text,
value
],
displayText:
text || value,
disabled:
optionLooksDisabled(
select,
null,
option
)
});
});
});
Array.prototype.slice.call(
scope.querySelectorAll(
[
"[data-option-value]",
".swatch-element label",
".product-form__input label",
".product-option label",
".variant-input label",
".variant__button-label",
".product-form__input button",
".product-option button",
"[data-value]"
].join(",")
)
).forEach(function(el){
if(
root &&
root.contains(el)
){
return;
}
var text =
cleanOptionText(
el.textContent
);
var dataValue =
cleanOptionText(
el.getAttribute(
"data-value"
)
);
var optionValue =
cleanOptionText(
el.getAttribute(
"data-option-value"
)
);
var ariaLabel =
cleanOptionText(
el.getAttribute(
"aria-label"
)
);
addEntry({
type:"button",
element:el,
clickTarget:el,
aliases:[
text,
dataValue,
optionValue,
ariaLabel
],
displayText:
text ||
optionValue ||
dataValue ||
ariaLabel,
disabled:
optionLooksDisabled(
el,
el,
null
)
});
});
return entries;
}
function findNativeOptionMatch(
root,
candidates,
entries
){
var list =
entries ||
collectNativeOptionEntries(root);
for(
var i = 0;
i < list.length;
i++
){
var entry =
list[i];
var matched =
entry.aliases.some(
function(alias){
return matchesCandidate(
alias,
candidates
);
}
);
if(matched){
return entry;
}
}
return null;
}
function selectNativeOptionEntry(entry){
if(
!entry ||
entry.disabled
){
return false;
}
if(
entry.type === "select" &&
entry.select &&
entry.option
){
entry.select.value =
entry.option.value;
dispatchChange(
entry.select
);
return true;
}
if(
entry.type === "radio" &&
entry.element
){
entry.element.checked =
true;
dispatchChange(
entry.element
);
if(
entry.clickTarget &&
typeof entry.clickTarget.click === "function"
){
entry.clickTarget.click();
}
return true;
}
if(
entry.clickTarget &&
typeof entry.clickTarget.click === "function"
){
entry.clickTarget.click();
return true;
}
return false;
}
function selectNativeSize(
root,
candidates
){
var match =
findNativeOptionMatch(
root,
candidates
);
return selectNativeOptionEntry(
match
);
}
function buildFootwearStoreRows(
root,
profile
){
var entries =
collectNativeOptionEntries(root);
var mapped = [];
profile.sizes.forEach(
function(row, index){
var match =
findNativeOptionMatch(
root,
footwearCandidates(
row,
profile
),
entries
);
if(match){
mapped.push({
row:row,
profileIndex:index,
storeOption:match
});
}
}
);
return {
entries:entries,
mapped:mapped
};
}
function findAddButton(root){
var directButton =
document.querySelector(
"#product-add-to-cart"
);
if(
directButton &&
!root.contains(directButton)
){
return directButton;
}
var selectors = [
".product-form__submit",
'[name="add"]',
'button[type="submit"][name="add"]',
'form[action*="/cart/add"] button[type="submit"]'
];
for(
var i = 0;
i < selectors.length;
i++
){
var buttons =
Array.prototype.slice.call(
document.querySelectorAll(
selectors[i]
)
);
for(
var j = 0;
j < buttons.length;
j++
){
if(
!root.contains(
buttons[j]
)
){
return buttons[j];
}
}
}
return null;
}
function nativeButtonUnavailable(button){
if(!button){
return true;
}
var text =
normalize(
button.textContent
);
return (
button.disabled ||
button.getAttribute(
"aria-disabled"
) === "true" ||
text.indexOf(
"soldout"
) !== -1 ||
text.indexOf(
"unavailable"
) !== -1
);
}
function selectRecommendation(root){
var recommendation =
root.__p817Recommendation;
if(!recommendation){
return;
}
var note =
qs(
root,
"[data-p817-result-note]"
);
if(
recommendation.storeOptionUnavailable
){
if(note){
note.hidden = false;
note.textContent =
recommendation.size +
" is your recommended size, but it is currently unavailable. We won’t substitute a different size.";
}
return;
}
var selected =
selectNativeSize(
root,
recommendation.variantCandidates ||
[recommendation.size]
);
if(!selected){
if(note){
note.hidden = false;
note.textContent =
"We verified your recommended size as " +
recommendation.size +
", but couldn’t automatically select the option on this product page. Please choose that exact size above.";
}
return;
}
var modal =
qs(
root,
"[data-p817-modal]"
);
if(modal){
modal.hidden = true;
}
var attempts = 0;
function clickWhenReady(){
attempts += 1;
var button =
findAddButton(root);
if(
button &&
!nativeButtonUnavailable(
button
)
){
button.click();
return;
}
if(attempts < 10){
window.setTimeout(
clickWhenReady,
150
);
}
}
window.setTimeout(
clickWhenReady,
150
);
}
function openExistingSizeChart(root){
var selectors = [
".p817-sizechart-trigger",
"[data-size-chart-trigger]",
"[data-open-size-chart]",
".size-chart-trigger"
];
for(
var i = 0;
i < selectors.length;
i++
){
var trigger =
document.querySelector(
selectors[i]
);
if(
trigger &&
!root.contains(trigger)
){
trigger.click();
return;
}
}
}
function initClothingFlat(
root,
profile
){
var state = {
step:1,
unit:"in",
fit:"comfortable"
};
var bustInput =
qs(
root,
"[data-p817-bust-flat]"
);
var waistInput =
qs(
root,
"[data-p817-waist-flat]"
);
setupUnitButtons(
root,
state,
[
bustInput,
waistInput
]
);
setupSteps(
root,
state,
function(step){
if(step === 1){
return showInputError(
bustInput
);
}
if(step === 2){
return showInputError(
waistInput
);
}
return true;
}
);
var form =
qs(
root,
"[data-p817-form]"
);
form.addEventListener(
"submit",
function(e){
e.preventDefault();
var bust =
valueToInches(
parseFloat(
bustInput.value
),
state.unit
);
var waist =
valueToInches(
parseFloat(
waistInput.value
),
state.unit
);
state.fit =
readFit(root);
var index = -1;
for(
var i = 0;
i < profile.sizes.length;
i++
){
if(
profile.sizes[i].bustIn >= bust &&
profile.sizes[i].waistIn >= waist
){
index = i;
break;
}
}
var outsideHigh =
false;
if(index === -1){
index =
profile.sizes.length - 1;
outsideHigh =
true;
}
var baseIndex =
index;
if(
state.fit === "roomy" &&
profile.allowSizeUp &&
index <
profile.sizes.length - 1
){
index += 1;
}
var row =
profile.sizes[index];
var copy =
"Based on the flat bust and waist measurements you entered, we recommend size " +
row.size +
".";
if(
state.fit === "roomy" &&
index > baseIndex
){
copy +=
" We moved you up one listed size because you selected a roomier fit.";
} else {
copy +=
" This is the smallest size in the chart that accommodates both measurements.";
}
var note = "";
if(outsideHigh){
note =
"Your measurements are above the largest measurements listed in this chart. " +
row.size +
" is the largest available chart size.";
}
setResult(
root,
{
size:row.size,
variantCandidates:
clothingCandidates(
row.size
),
conversions:
"<span>Bust: " +
round(
row.bustIn,
2
) +
" in</span>" +
"<span>Waist: " +
round(
row.waistIn,
2
) +
" in</span>" +
"<span>Length: " +
round(
row.lengthIn,
2
) +
" in</span>",
copy:copy,
note:note
}
);
}
);
}
function initClothingWidth(
root,
profile
){
var state = {
step:1,
unit:"in",
fit:"comfortable"
};
var widthInput =
qs(
root,
"[data-p817-width-flat]"
);
setupUnitButtons(
root,
state,
[widthInput]
);
setupSteps(
root,
state,
function(step){
if(step === 1){
return showInputError(
widthInput
);
}
return true;
}
);
var form =
qs(
root,
"[data-p817-form]"
);
form.addEventListener(
"submit",
function(e){
e.preventDefault();
var width =
valueToInches(
parseFloat(
widthInput.value
),
state.unit
);
state.fit =
readFit(root);
var index = -1;
for(
var i = 0;
i < profile.sizes.length;
i++
){
if(
profile.sizes[i].widthIn >=
width
){
index = i;
break;
}
}
var outsideHigh =
false;
if(index === -1){
index =
profile.sizes.length - 1;
outsideHigh =
true;
}
var baseIndex =
index;
if(
state.fit === "roomy" &&
profile.allowSizeUp &&
index <
profile.sizes.length - 1
){
index += 1;
}
var row =
profile.sizes[index];
var copy =
"Based on the flat garment width you entered, we recommend size " +
row.size +
".";
if(
profile.garmentType ===
"unisex_tee" &&
state.fit === "roomy" &&
index > baseIndex
){
copy +=
" We moved you up one size for the looser streetwear fit you selected.";
} else if(
state.fit === "roomy" &&
index > baseIndex
){
copy +=
" We moved you up one listed size for the extra room you selected.";
} else {
copy +=
" This is the smallest chart size that accommodates the width you entered.";
}
var conversions =
"<span>Width: " +
round(
row.widthIn,
2
) +
" in</span>";
if(
row.lengthIn != null
){
conversions +=
"<span>Length: " +
round(
row.lengthIn,
2
) +
" in</span>";
}
if(
row.sleeveIn != null
){
conversions +=
"<span>Sleeve: " +
round(
row.sleeveIn,
2
) +
" in</span>";
}
var note = "";
if(outsideHigh){
note =
"Your measurement is above the largest width listed in this chart. " +
row.size +
" is the largest available chart size.";
} else if(
state.fit === "roomy" &&
profile.allowSizeUp &&
baseIndex ===
profile.sizes.length - 1
){
note =
row.size +
" is already the largest listed size, so we can’t move the recommendation up another size.";
}
setResult(
root,
{
size:row.size,
variantCandidates:
clothingCandidates(
row.size
),
conversions:
conversions,
copy:copy,
note:note
}
);
}
);
}
function initClothingBody(
root,
profile
){
var state = {
step:1,
unit:"in",
fit:"comfortable"
};
var bustInput =
qs(
root,
"[data-p817-body-bust]"
);
var waistInput =
qs(
root,
"[data-p817-body-waist]"
);
var hipInput =
qs(
root,
"[data-p817-body-hip]"
);
setupUnitButtons(
root,
state,
[
bustInput,
waistInput,
hipInput
]
);
setupSteps(
root,
state,
function(step){
if(step === 1){
return showInputError(
bustInput
);
}
if(step === 2){
return (
showInputError(
waistInput
) &&
showInputError(
hipInput
)
);
}
return true;
}
);
var form =
qs(
root,
"[data-p817-form]"
);
form.addEventListener(
"submit",
function(e){
e.preventDefault();
var bust =
valueToInches(
parseFloat(
bustInput.value
),
state.unit
);
var waist =
valueToInches(
parseFloat(
waistInput.value
),
state.unit
);
var hip =
valueToInches(
parseFloat(
hipInput.value
),
state.unit
);
state.fit =
readFit(root);
var index = -1;
for(
var i = 0;
i < profile.sizes.length;
i++
){
var row =
profile.sizes[i];
if(
row.bustIn >= bust &&
row.waistIn >= waist &&
row.hipIn >= hip
){
index = i;
break;
}
}
var outsideHigh =
false;
if(index === -1){
index =
profile.sizes.length - 1;
outsideHigh =
true;
}
var baseIndex =
index;
if(
state.fit === "roomy" &&
profile.allowSizeUp &&
index <
profile.sizes.length - 1
){
index += 1;
}
var resultRow =
profile.sizes[index];
var copy =
"Based on your bust, waist, and hip measurements, we recommend size " +
resultRow.size +
".";
if(
state.fit === "roomy" &&
index > baseIndex
){
copy +=
" Your measurements match the size below, but we moved you up one listed size because you selected more breathing room.";
} else {
copy +=
" This is the smallest size in the chart that accommodates all three measurements.";
}
var note = "";
if(outsideHigh){
note =
"One or more of your measurements are above the largest measurements listed in this chart. " +
resultRow.size +
" is the largest available chart size.";
} else if(
state.fit === "roomy" &&
baseIndex ===
profile.sizes.length - 1
){
note =
resultRow.size +
" is already the largest listed size, so we can’t move the recommendation up another size.";
}
setResult(
root,
{
size:
resultRow.size,
variantCandidates:
clothingCandidates(
resultRow.size
),
conversions:
"<span>Bust: " +
round(
resultRow.bustIn,
2
) +
" in</span>" +
"<span>Waist: " +
round(
resultRow.waistIn,
2
) +
" in</span>" +
"<span>Hips: " +
round(
resultRow.hipIn,
2
) +
" in</span>",
copy:copy,
note:note
}
);
}
);
}
function initClothingSetFlat(
root,
profile
){
var state = {
step:1,
unit:"in",
fit:"comfortable"
};
var chestInput =
qs(
root,
"[data-p817-set-chest]"
);
var waistInput =
qs(
root,
"[data-p817-set-waist]"
);
var hipInput =
qs(
root,
"[data-p817-set-hip]"
);
setupUnitButtons(
root,
state,
[
chestInput,
waistInput,
hipInput
]
);
setupSteps(
root,
state,
function(step){
if(step === 1){
return showInputError(
chestInput
);
}
if(step === 2){
return (
showInputError(
waistInput
) &&
showInputError(
hipInput
)
);
}
return true;
}
);
var form =
qs(
root,
"[data-p817-form]"
);
form.addEventListener(
"submit",
function(e){
e.preventDefault();
var chest =
valueToInches(
parseFloat(
chestInput.value
),
state.unit
);
var waist =
valueToInches(
parseFloat(
waistInput.value
),
state.unit
);
var hip =
valueToInches(
parseFloat(
hipInput.value
),
state.unit
);
state.fit =
readFit(root);
var index = -1;
for(
var i = 0;
i < profile.sizes.length;
i++
){
var row =
profile.sizes[i];
if(
row.chestIn >= chest &&
row.waistIn >= waist &&
row.hipIn >= hip
){
index = i;
break;
}
}
var outsideHigh =
false;
if(index === -1){
index =
profile.sizes.length - 1;
outsideHigh =
true;
}
var baseIndex =
index;
if(
state.fit === "roomy" &&
profile.allowSizeUp &&
index <
profile.sizes.length - 1
){
index += 1;
}
var resultRow =
profile.sizes[index];
var copy =
"Based on the top chest, bottom waist, and bottom hip measurements you entered, we recommend size " +
resultRow.size +
".";
if(
state.fit === "roomy" &&
index > baseIndex
){
copy +=
" We moved you up one listed size because you selected more room.";
} else {
copy +=
" This is the smallest size in the chart that accommodates all three measurements.";
}
var note = "";
if(outsideHigh){
note =
"One or more measurements are above the largest measurements listed in this chart. " +
resultRow.size +
" is the largest available chart size.";
} else if(
state.fit === "roomy" &&
baseIndex ===
profile.sizes.length - 1
){
note =
resultRow.size +
" is already the largest listed size, so we can’t move the recommendation up another size.";
}
setResult(
root,
{
size:
resultRow.size,
variantCandidates:
clothingCandidates(
resultRow.size
),
conversions:
"<span>Top chest: " +
round(
resultRow.chestIn,
2
) +
" in</span>" +
"<span>Bottom waist: " +
round(
resultRow.waistIn,
2
) +
" in</span>" +
"<span>Bottom hips: " +
round(
resultRow.hipIn,
2
) +
" in</span>",
copy:copy,
note:note
}
);
}
);
}
function initClothingBottomFlat(
root,
profile
){
var state = {
step:1,
unit:"in",
fit:"comfortable"
};
var waistInput =
qs(
root,
"[data-p817-bottom-waist]"
);
var hipInput =
qs(
root,
"[data-p817-bottom-hip]"
);
setupUnitButtons(
root,
state,
[
waistInput,
hipInput
]
);
setupSteps(
root,
state,
function(step){
if(step === 1){
return showInputError(
waistInput
);
}
if(step === 2){
return showInputError(
hipInput
);
}
return true;
}
);
var form =
qs(
root,
"[data-p817-form]"
);
form.addEventListener(
"submit",
function(e){
e.preventDefault();
var waist =
valueToInches(
parseFloat(
waistInput.value
),
state.unit
);
var hip =
valueToInches(
parseFloat(
hipInput.value
),
state.unit
);
state.fit =
readFit(root);
var index = -1;
for(
var i = 0;
i < profile.sizes.length;
i++
){
var row =
profile.sizes[i];
if(
row.waistIn >= waist &&
row.hipIn >= hip
){
index = i;
break;
}
}
var outsideHigh =
false;
if(index === -1){
index =
profile.sizes.length - 1;
outsideHigh =
true;
}
var baseIndex =
index;
if(
state.fit === "roomy" &&
profile.allowSizeUp &&
index <
profile.sizes.length - 1
){
index += 1;
}
var resultRow =
profile.sizes[index];
var copy =
"Based on the flat waist and hip measurements you entered, we recommend size " +
resultRow.size +
".";
if(
state.fit === "roomy" &&
index > baseIndex
){
copy +=
" We moved you up one listed size for the looser streetwear fit you selected.";
} else {
copy +=
" This is the smallest size in the chart that accommodates both measurements.";
}
var note = "";
if(outsideHigh){
note =
"One or both of your measurements are above the largest measurements listed in this chart. " +
resultRow.size +
" is the largest available chart size.";
} else if(
state.fit === "roomy" &&
baseIndex ===
profile.sizes.length - 1
){
note =
resultRow.size +
" is already the largest listed size, so we can’t move the recommendation up another size.";
}
var conversions =
"<span>Waist: " +
round(
resultRow.waistIn,
2
) +
" in</span>" +
"<span>Hips: " +
round(
resultRow.hipIn,
2
) +
" in</span>";
if(
resultRow.inseamIn != null
){
conversions +=
"<span>Inseam: " +
round(
resultRow.inseamIn,
2
) +
" in</span>";
}
if(
resultRow.totalLengthIn != null
){
conversions +=
"<span>Total length: " +
round(
resultRow.totalLengthIn,
2
) +
" in</span>";
}
setResult(
root,
{
size:
resultRow.size,
variantCandidates:
clothingCandidates(
resultRow.size
),
conversions:
conversions,
copy:copy,
note:note
}
);
}
);
}
function initClothingBikiniFlat(
root,
profile
){
var state = {
step:1,
unit:"in",
fit:"comfortable"
};
var cupWidthInput =
qs(
root,
"[data-p817-bikini-cup-width]"
);
var cupHeightInput =
qs(
root,
"[data-p817-bikini-cup-height]"
);
var frontRiseInput =
qs(
root,
"[data-p817-bikini-front-rise]"
);
var backRiseInput =
qs(
root,
"[data-p817-bikini-back-rise]"
);
setupUnitButtons(
root,
state,
[
cupWidthInput,
cupHeightInput,
frontRiseInput,
backRiseInput
]
);
setupSteps(
root,
state,
function(step){
if(step === 1){
return (
showInputError(
cupWidthInput
) &&
showInputError(
cupHeightInput
)
);
}
if(step === 2){
return (
showInputError(
frontRiseInput
) &&
showInputError(
backRiseInput
)
);
}
return true;
}
);
var form =
qs(
root,
"[data-p817-form]"
);
form.addEventListener(
"submit",
function(e){
e.preventDefault();
var cupWidth =
valueToInches(
parseFloat(
cupWidthInput.value
),
state.unit
);
var cupHeight =
valueToInches(
parseFloat(
cupHeightInput.value
),
state.unit
);
var frontRise =
valueToInches(
parseFloat(
frontRiseInput.value
),
state.unit
);
var backRise =
valueToInches(
parseFloat(
backRiseInput.value
),
state.unit
);
state.fit =
readFit(root);
var index = -1;
for(
var i = 0;
i < profile.sizes.length;
i++
){
var row =
profile.sizes[i];
if(
row.cupWidthIn >= cupWidth &&
row.cupHeightIn >= cupHeight &&
row.frontRiseIn >= frontRise &&
row.backRiseIn >= backRise
){
index = i;
break;
}
}
var outsideHigh =
false;
if(index === -1){
index =
profile.sizes.length - 1;
outsideHigh =
true;
}
var baseIndex =
index;
if(
state.fit === "roomy" &&
profile.allowSizeUp &&
index <
profile.sizes.length - 1
){
index += 1;
}
var resultRow =
profile.sizes[index];
var copy =
"Based on the bikini measurements you entered, we recommend size " +
resultRow.size +
".";
if(
state.fit === "roomy" &&
index > baseIndex
){
copy +=
" We moved you up one listed size because you selected more coverage.";
} else {
copy +=
" This is the smallest chart size that accommodates all four measurements.";
}
var note = "";
if(outsideHigh){
note =
"One or more of your measurements are above the largest measurements listed in this chart. " +
resultRow.size +
" is the largest available chart size.";
} else if(
state.fit === "roomy" &&
baseIndex ===
profile.sizes.length - 1
){
note =
resultRow.size +
" is already the largest listed size, so we can’t move the recommendation up another size.";
}
setResult(
root,
{
size:
resultRow.size,
variantCandidates:
clothingCandidates(
resultRow.size
),
conversions:
"<span>Cup width: " +
round(
resultRow.cupWidthIn,
2
) +
" in</span>" +
"<span>Cup height: " +
round(
resultRow.cupHeightIn,
2
) +
" in</span>" +
"<span>Front rise: " +
round(
resultRow.frontRiseIn,
2
) +
" in</span>" +
"<span>Back rise: " +
round(
resultRow.backRiseIn,
2
) +
" in</span>",
copy:copy,
note:note
}
);
}
);
}
function initClothingTopFlat(
root,
profile
){
var state = {
step:1,
unit:"in",
fit:"comfortable"
};
var chestInput =
qs(
root,
"[data-p817-top-chest]"
);
var waistbandInput =
qs(
root,
"[data-p817-top-waistband]"
);
setupUnitButtons(
root,
state,
[
chestInput,
waistbandInput
]
);
setupSteps(
root,
state,
function(step){
if(step === 1){
return showInputError(
chestInput
);
}
if(step === 2){
return showInputError(
waistbandInput
);
}
return true;
}
);
var form =
qs(
root,
"[data-p817-form]"
);
form.addEventListener(
"submit",
function(e){
e.preventDefault();
var chest =
valueToInches(
parseFloat(
chestInput.value
),
state.unit
);
var waistband =
valueToInches(
parseFloat(
waistbandInput.value
),
state.unit
);
state.fit =
readFit(root);
var index = -1;
for(
var i = 0;
i < profile.sizes.length;
i++
){
var row =
profile.sizes[i];
if(
row.chestIn >= chest &&
row.waistbandIn >= waistband
){
index = i;
break;
}
}
var outsideHigh =
false;
if(index === -1){
index =
profile.sizes.length - 1;
outsideHigh =
true;
}
var baseIndex =
index;
if(
state.fit === "roomy" &&
profile.allowSizeUp &&
index <
profile.sizes.length - 1
){
index += 1;
}
var resultRow =
profile.sizes[index];
var copy =
"Based on the flat chest and waistband measurements you entered, we recommend size " +
resultRow.size +
".";
if(
state.fit === "roomy" &&
index > baseIndex
){
copy +=
" We moved you up one listed size for the looser crop you selected.";
} else {
copy +=
" This is the smallest size in the chart that accommodates both measurements.";
}
var note = "";
if(outsideHigh){
note =
"One or both of your measurements are above the largest measurements listed in this chart. " +
resultRow.size +
" is the largest available chart size.";
} else if(
state.fit === "roomy" &&
baseIndex ===
profile.sizes.length - 1
){
note =
resultRow.size +
" is already the largest listed size, so we can’t move the recommendation up another size.";
}
setResult(
root,
{
size:
resultRow.size,
variantCandidates:
clothingCandidates(
resultRow.size
),
conversions:
"<span>Chest: " +
round(
resultRow.chestIn,
2
) +
" in</span>" +
"<span>Waistband: " +
round(
resultRow.waistbandIn,
2
) +
" in</span>" +
"<span>Front length: " +
round(
resultRow.frontLengthIn,
2
) +
" in</span>",
copy:copy,
note:note
}
);
}
);
}
function initFootwear(
root,
profile
){
var state = {
step:1,
unit:"cm",
fit:"comfortable",
system:"women"
};
var measureInput =
qs(
root,
"[data-p817-foot-length]"
);
var usualSelect =
qs(
root,
"[data-p817-usual-size]"
);
var thickSocks =
qs(
root,
"[data-p817-thick-socks]"
);
setupUnitButtons(
root,
state,
[measureInput]
);
setupSteps(
root,
state,
function(step){
if(step === 1){
return showInputError(
measureInput
);
}
return true;
}
);
function populateUsualSizes(){
if(!usualSelect){
return;
}
var values = [];
profile.sizes.forEach(
function(row){
if(
state.system === "women" &&
row.women
){
values.push(
row.women
);
}
if(
state.system === "men" &&
row.men
){
values.push(
row.men
);
}
if(
state.system === "eur" &&
row.eur
){
values.push(
row.eur
);
}
if(
state.system === "uk" &&
row.uk
){
values.push(
row.uk
);
}
}
);
values =
unique(values);
usualSelect.innerHTML =
'<option value="">Select size</option>' +
values.map(
function(value){
return (
'<option value="' +
escapeHtml(value) +
'">' +
escapeHtml(value) +
"</option>"
);
}
).join("");
}
qsa(
root,
"[data-p817-system]"
).forEach(function(button){
button.addEventListener(
"click",
function(){
state.system =
button.getAttribute(
"data-p817-system"
);
qsa(
root,
"[data-p817-system]"
).forEach(function(btn){
btn.classList.toggle(
"is-active",
btn === button
);
});
populateUsualSizes();
}
);
});
populateUsualSizes();
var form =
qs(
root,
"[data-p817-form]"
);
form.addEventListener(
"submit",
function(e){
e.preventDefault();
var entered =
valueToCm(
parseFloat(
measureInput.value
),
state.unit
);
state.fit =
readFit(root);
var storeData =
buildFootwearStoreRows(
root,
profile
);
var mappedRows =
storeData.mapped;
var hasStoreMapping =
mappedRows.length > 0;
var eligibleRows =
hasStoreMapping
? mappedRows
: profile.sizes.map(
function(row, index){
return {
row:row,
profileIndex:index,
storeOption:null
};
}
);
var targetCm =
entered;
var chosenEligibleIndex =
-1;
if(
profile.measurementMode ===
"insole_reference"
){
for(
var i = 0;
i < eligibleRows.length;
i++
){
if(
eligibleRows[i].row.insoleCm >=
entered
){
chosenEligibleIndex = i;
break;
}
}
if(chosenEligibleIndex === -1){
chosenEligibleIndex =
eligibleRows.length - 1;
}
var needsUp =
state.fit === "roomy" ||
(
thickSocks &&
thickSocks.checked
);
if(
needsUp &&
chosenEligibleIndex <
eligibleRows.length - 1
){
chosenEligibleIndex += 1;
}
} else {
var allowance =
profile.toeRoom &&
profile.toeRoom[state.fit] != null
? profile.toeRoom[state.fit]
: 0.65;
targetCm +=
allowance;
if(
thickSocks &&
thickSocks.checked
){
targetCm +=
profile.sockAllowance ||
0.10;
}
for(
var j = 0;
j < eligibleRows.length;
j++
){
if(
eligibleRows[j].row.insoleCm >=
targetCm
){
chosenEligibleIndex = j;
break;
}
}
if(chosenEligibleIndex === -1){
chosenEligibleIndex =
eligibleRows.length - 1;
}
}
if(
chosenEligibleIndex < 0 ||
!eligibleRows.length
){
return;
}
var chosen =
eligibleRows[
chosenEligibleIndex
];
var row =
chosen.row;
var storefrontOption =
chosen.storeOption;
var displaySize =
storefrontOption &&
storefrontOption.displayText
? storefrontOption.displayText
: footwearStoreSize(
row,
profile
);
var variantCandidates =
footwearCandidates(
row,
profile
);
if(displaySize){
variantCandidates =
unique(
[displaySize].concat(
variantCandidates
)
);
}
var conversions =
"";
if(row.women){
conversions +=
"<span>US Women: " +
escapeHtml(
row.women
) +
"</span>";
}
if(row.men){
conversions +=
"<span>US Men: " +
escapeHtml(
row.men
) +
"</span>";
}
if(row.eur){
conversions +=
"<span>EUR: " +
escapeHtml(
row.eur
) +
"</span>";
}
if(row.uk){
conversions +=
"<span>UK: " +
escapeHtml(
row.uk
) +
"</span>";
}
conversions +=
"<span>" +
(
profile.measurementMode ===
"insole_reference"
? "Insole"
: "Chart length"
) +
": " +
round(
row.insoleCm,
2
) +
" cm</span>";
var copy;
if(
profile.measurementMode ===
"insole_reference"
){
copy =
"Based on the reference measurement you entered, we recommend " +
displaySize +
".";
if(
state.fit === "roomy" ||
(
thickSocks &&
thickSocks.checked
)
){
copy +=
" We allowed one listed size up for the extra room you selected.";
} else {
copy +=
" This is the closest verified product size at or above your reference measurement.";
}
} else {
copy =
"Based on your foot length and the fit preference you selected, we recommend " +
displaySize +
".";
if(hasStoreMapping){
copy +=
" This recommendation was checked against the sizes currently listed on this product.";
}
}
var note = "";
if(!hasStoreMapping){
note =
"We could not read the product’s size options automatically, so this recommendation is based on the size chart only.";
}
if(
storefrontOption &&
storefrontOption.disabled
){
note =
displaySize +
" is your recommended size, but it is currently unavailable. We won’t substitute a different size.";
}
setResult(
root,
{
size:
displaySize,
variantCandidates:
variantCandidates,
conversions:
conversions,
copy:
copy,
note:
note,
storeOptionVerified:
!!storefrontOption,
storeOptionUnavailable:
!!(
storefrontOption &&
storefrontOption.disabled
)
}
);
}
);
}
function init(root){
if(
!root ||
root.__p817Initialized
){
return;
}
root.__p817Initialized =
true;
var profileKey =
root.getAttribute(
"data-profile"
);
var profile =
PROFILES[profileKey];
if(!profile){
return;
}
var modal =
qs(
root,
"[data-p817-modal]"
);
var open =
qs(
root,
"[data-p817-open]"
);
var start =
qs(
root,
"[data-p817-start]"
);
var restart =
qs(
root,
"[data-p817-restart]"
);
var selectSize =
qs(
root,
"[data-p817-select-size]"
);
var viewChart =
qs(
root,
"[data-p817-view-chart]"
);
var hint =
qs(
root,
"[data-p817-profile-hint]"
);
if(
hint &&
profile.hint
){
hint.textContent =
profile.hint;
}
if(
open &&
modal
){
open.addEventListener(
"click",
function(){
modal.hidden =
false;
document
.documentElement
.classList
.add(
"p817-sf-open"
);
}
);
}
qsa(
root,
"[data-p817-close]"
).forEach(function(button){
button.addEventListener(
"click",
function(){
if(modal){
modal.hidden =
true;
}
document
.documentElement
.classList
.remove(
"p817-sf-open"
);
}
);
});
if(start){
start.addEventListener(
"click",
function(){
showScreen(
root,
"form"
);
showStep(
root,
1
);
}
);
}
if(restart){
restart.addEventListener(
"click",
function(){
showScreen(
root,
"intro"
);
var form =
qs(
root,
"[data-p817-form]"
);
if(form){
form.reset();
}
qsa(
root,
".p817-sf__choice"
).forEach(
function(choice){
var input =
qs(
choice,
'input[type="radio"]'
);
choice
.classList
.toggle(
"is-selected",
!!(
input &&
input.checked
)
);
}
);
root.__p817Recommendation =
null;
}
);
}
if(selectSize){
selectSize.addEventListener(
"click",
function(){
selectRecommendation(
root
);
}
);
}
if(viewChart){
viewChart.addEventListener(
"click",
function(){
if(modal){
modal.hidden =
true;
}
document
.documentElement
.classList
.remove(
"p817-sf-open"
);
window.setTimeout(
function(){
openExistingSizeChart(
root
);
},
50
);
}
);
}
setupChoices(root);
if(
profile.type ===
"clothing_flat"
){
initClothingFlat(
root,
profile
);
}
else if(
profile.type ===
"clothing_width"
){
initClothingWidth(
root,
profile
);
}
else if(
profile.type ===
"clothing_body"
){
initClothingBody(
root,
profile
);
}
else if(
profile.type ===
"clothing_set_flat"
){
initClothingSetFlat(
root,
profile
);
}
else if(
profile.type ===
"clothing_bottom_flat"
){
initClothingBottomFlat(
root,
profile
);
}
else if(
profile.type ===
"clothing_bikini_flat"
){
initClothingBikiniFlat(
root,
profile
);
}
else if(
profile.type ===
"clothing_top_flat"
){
initClothingTopFlat(
root,
profile
);
}
else if(
profile.type ===
"footwear"
){
initFootwear(
root,
profile
);
}
}
function boot(){
document
.querySelectorAll(
"[data-p817-size-finder]"
)
.forEach(init);
}
if(
document.readyState ===
"loading"
){
document.addEventListener(
"DOMContentLoaded",
boot
);
} else {
boot();
}
})();
/* =========================================
   P817 SIZE FINDER — PRODUCT IMAGE
   ========================================= */

(function(){
  function initP817ProductImages(){
    document.querySelectorAll("[data-p817-size-finder]").forEach(function(root){
      var imageUrl = root.getAttribute("data-product-image");
      var productTitle = root.getAttribute("data-product-title") || "Product";

      var visual = root.querySelector("[data-p817-product-visual]");
      var image = root.querySelector("[data-p817-product-image]");

      if(!visual || !image){
        return;
      }

      if(!imageUrl){
        visual.hidden = true;
        return;
      }

      image.src = imageUrl;
      image.alt = productTitle;

      image.onload = function(){
        visual.hidden = false;
      };

      image.onerror = function(){
        visual.hidden = true;
      };

      if(image.complete && image.naturalWidth > 0){
        visual.hidden = false;
      }
    });
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", initP817ProductImages);
  }else{
    initP817ProductImages();
  }

  document.addEventListener("shopify:section:load", initP817ProductImages);
})();

/* =========================================
   P817 SIZE FINDER — IOS DECIMAL INPUT FIX
   ========================================= */

(function () {
  function fixP817MeasurementInputs() {
    document
      .querySelectorAll('[data-p817-size-finder] input[type="number"]')
      .forEach(function (input) {
        input.setAttribute("type", "text");
        input.setAttribute("inputmode", "decimal");
        input.setAttribute("autocomplete", "off");

        input.removeAttribute("step");
        input.removeAttribute("min");

        input.addEventListener("input", function () {
          var value = input.value;

          value = value.replace(",", ".");

          value = value.replace(/[^0-9.]/g, "");

          var firstDot = value.indexOf(".");
          if (firstDot !== -1) {
            value =
              value.slice(0, firstDot + 1) +
              value.slice(firstDot + 1).replace(/\./g, "");
          }

          input.value = value;
        });
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fixP817MeasurementInputs);
  } else {
    fixP817MeasurementInputs();
  }

  document.addEventListener("shopify:section:load", fixP817MeasurementInputs);
  document.addEventListener("shopify:section:load", fixP817MeasurementInputs);

  // ── Size chart toggle ──────────────────────────────────────────────
  document.querySelectorAll('[data-p817-chart-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var body = btn.closest('.p817-sf__body');
      if (!body) return;

      var wrap = body.querySelector('.p817-sf__chart-wrap');
      if (!wrap) return;

      var isHidden = wrap.hasAttribute('hidden');

      if (isHidden) {
        wrap.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = '− Hide Size Chart';
      } else {
        wrap.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = '+ View Size Chart';
      }
    });
  });

})();
